import React, { useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

interface Props {
  children: React.ReactNode;
  onClose: () => void;
  onPrevious?: () => void;
  onNext?: () => void;
  position: string;
  title: string;
  activeKey: string;
}
export default function LeadDrawer({ children, onClose, onPrevious, onNext, position, title, activeKey }: Props) {
  const dialog = useRef<HTMLDialogElement>(null);
  const body = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = dialog.current!;
    const focused = document.activeElement as HTMLElement | null;
    const previousOverflow = document.body.style.overflow;
    element.showModal(); document.body.style.overflow = 'hidden';
    return () => { element.close(); document.body.style.overflow = previousOverflow; if (focused?.isConnected) focused.focus(); };
  }, []);
  useEffect(() => { body.current?.scrollTo({ top: 0 }); }, [activeKey]);
  return <dialog ref={dialog} className="prospect-lead-dialog" aria-labelledby="prospect-drawer-title" onCancel={event => { event.preventDefault(); if (!dialog.current?.querySelector('[role="dialog"]')) onClose(); }}>
    <header className="prospect-drawer-heading"><h2 id="prospect-drawer-title">{title}</h2><div><span>{position}</span>{position && <><button type="button" className="prospect-icon" title="Lead anterior" aria-label="Lead anterior" disabled={!onPrevious} onClick={onPrevious}><ChevronLeft size={18}/></button><button type="button" className="prospect-icon" title="Próximo lead" aria-label="Próximo lead" disabled={!onNext} onClick={onNext}><ChevronRight size={18}/></button></>}<button type="button" className="prospect-icon" title="Fechar lead" aria-label="Fechar lead" onClick={onClose} autoFocus><X size={18}/></button></div></header>
    <div className="prospect-drawer-body" ref={body}>{children}</div>
  </dialog>;
}
